import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { NavigationEnd, NavigationCancel, Router, ActivatedRoute, PRIMARY_OUTLET, Params } from '@angular/router';
import { filter, tap, distinctUntilChanged } from 'rxjs';
import { Location } from '@angular/common';

interface StateData{
  data : {
    [k: string] : string
  }
}

interface BreadcrumbInterface {
  label: string;
  params: Params;
  url: string;
  state: StateData | null
}

@Component({
  standalone: false,
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class BreadcrumbComponent implements OnInit {
  dashboard: string = 'Dashboard';
  public breadcrumbs: BreadcrumbInterface[];
  public dashboaordData: Partial<BreadcrumbInterface> = {
    url: 'm/applobby'
  }
  navigationEvent = this.router.events;
  navigationEventEnd = this.navigationEvent.pipe(
    filter(event => event instanceof NavigationEnd || event instanceof NavigationCancel),
    tap(() => { this.breadcrumbs = this.getBreadcrumbs(this.activatedRoute.root); })
  );

  constructor(
    private readonly router: Router,
    private readonly activatedRoute: ActivatedRoute,
    private readonly location: Location
  ) {
    this.breadcrumbs = this.getBreadcrumbs(this.activatedRoute.root);
  }

  ngOnInit() {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      distinctUntilChanged()
    ).subscribe((event) => {
      this.breadcrumbs = this.getBreadcrumbs(this.activatedRoute.root)
    })
  }


  private getBreadcrumbs(

    route: ActivatedRoute, url: string = '',
    breadcrumbs: BreadcrumbInterface[] = []): BreadcrumbInterface[] {
    const ROUTE_DATA_BREADCRUMB = 'breadcrumb';

    const children: ActivatedRoute[] = route?.children ?? [];
    if (children.length === 0) {
      return breadcrumbs;
    }

    for (const child of children) {
      if (child.outlet !== PRIMARY_OUTLET) {
        continue;
      }
      const snapshot = child.snapshot;
      const routeData = snapshot?.data;

      if (!snapshot) {
        return this.getBreadcrumbs(child, url, breadcrumbs);
      }

      if (!routeData || routeData.hasOwnProperty(ROUTE_DATA_BREADCRUMB) === false) {
        return this.getBreadcrumbs(child, url, breadcrumbs);
      }

      const routeSegments = snapshot.url ?? [];
      const routeURL: string = routeSegments.map(segment => segment.path).join('/');

      url += `/${routeURL}`;

      const details = this.breadcrumbDetails(child)
      const label = details.label;
      const data = details.data;

      const breadcrumb: BreadcrumbInterface = {
        label,
        params: snapshot.params ?? {},
        url,
        state: data
      };
      if (breadcrumb.label) {
        breadcrumbs.push(breadcrumb); 
      }
      return this.getBreadcrumbs(child, url, breadcrumbs);
    }
    return [];
  }


  breadcrumbDetails(child: ActivatedRoute) {
    const ROUTE_DATA_BREADCRUMB = 'breadcrumb';
    const DYNAMIC_BREADCRUMB_KEY = 'DYNAMIC_BREADCRUMB_KEY';
    const snapshot = child.snapshot;
    const routeData = snapshot?.data ?? {};
    let label = routeData[ROUTE_DATA_BREADCRUMB] ?? '';
    let key;
    let data: StateData | null = null;
    if (routeData.hasOwnProperty(DYNAMIC_BREADCRUMB_KEY)) {
      if(this.location.getState() !== undefined){
        data = this.location.getState() as StateData;
      }
      key = routeData[DYNAMIC_BREADCRUMB_KEY];
      if(data?.data){
        label = data.data[key];
      }
    }
    return { label, key, data }
  }
  

  navigate(breadcrumb: Partial<BreadcrumbInterface>) {
    let data;
    if(breadcrumb.state === null){
      this.router.navigate([breadcrumb.url])
    }
    else {
      this.router.navigate([breadcrumb.url], {
        state: { data }
      })
    }
  }


}

